"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import LoadingSpinner from "@/components/LoadingSpinner";

export default function EditorIndexPage() {
  const router = useRouter();

  useEffect(() => {
    // Redirect to dashboard when accessing /editor/ without a tool
    router.replace("/dashboard");
  }, [router]);

  // Show loading state while redirecting
  return <LoadingSpinner fullScreen text="Redirecting to dashboard..." />;
}
